export default __webpack_public_path__ + "static/media/accessories-2.fadfa47e.png";